import { combineReducers } from 'redux';

import loadSiteGoogleAnalyticsError from './loadSiteGoogleAnalyticsError';
import editSiteGoogleAnalyticsError from './editSiteGoogleAnalyticsError';


export default combineReducers({
  loadSiteGoogleAnalyticsError,
  editSiteGoogleAnalyticsError,
});
